import { FC, useContext, useEffect, useLayoutEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FooterText from "src/components/footerText";
import useFetch from "src/hooks/useFetch";
import { LoaderContext } from "src/context/loaderContext";
import { EOBsDetailAPIResponseType } from "./types";
import { APIEndpoints } from "src/types/apiTypes";
import AuthSubHeader from "../../components/authSubHeader";
import EOBsInformation from "src/components/EOBsInformation";
import { ToastContext } from "src/context/toastContext";
import { ToastTypes } from "src/types";

const EOBsDetail: FC = (): JSX.Element => {
  const { id } = useParams();
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { showToast } = useContext(ToastContext)
  const navigate = useNavigate();


  useLayoutEffect(() => {
    setLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { data: uploadEOBsObject } =
    useFetch<EOBsDetailAPIResponseType>(APIEndpoints.EOBs_DETAIL, {}, { id });

  useEffect(() => {
    if (uploadEOBsObject) {
      hideLoader();
      if (uploadEOBsObject.status === 404) {
        showToast(["EOB Not Found"], ToastTypes.ERROR)
        navigate('/explanationOfBenefit')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadEOBsObject]);

  return (
    <div className="body-bg overflow-auto flex-fill">
      <div className="container pt-2">
        <AuthSubHeader />
        {uploadEOBsObject && uploadEOBsObject?.status !== 404 && <EOBsInformation EOBsObject={uploadEOBsObject} />}
        <div className="mt-3"><FooterText footerType="black" /></div>
      </div>
    </div>
  );
};

export default EOBsDetail;
